import { render, staticRenderFns } from "./AddUserSignerDialog.vue?vue&type=template&id=37d7621c"
import script from "./AddUserSignerDialog.js?vue&type=script&lang=js&external"
export * from "./AddUserSignerDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports